import { UserModel } from 'app/models/user.model';

const orderedRoutes = ['/wallet', '/productions', '/crm', '/sales', '/finance', '/clients', '/carriers', '/suppliers', '/products', '/users', '/nfe'];

function canAccessRoute(user: UserModel, route: string): boolean {
    if (user?.isAdmin) {
        return true;
    }

    switch (route) {
        case '/wallet':
            return !!user?.permission?.can_access_wallet;
        case '/sales':
            return !!user?.permission?.can_access_sale;
        case '/finance':
            return !!user?.permission?.can_access_finance;
        case '/clients':
            return (
                !!user?.permission?.can_access_clients ||
                !!user?.permission?.view_clients_wallet_or_own_confirmed_sales
            );
        case '/carriers':
            return !!user?.permission?.can_access_carriers;
        case '/suppliers':
            return !!user?.permission?.can_access_suppliers;
        case '/products':
            return !!user?.permission?.can_access_products;
        case '/users':
            return !!user?.permission?.can_access_users;
        case '/nfe':
            return false;
        case '/productions':
        case '/crm':
            return true;
        default:
            return false;
    }
}

export function getNextAllowedRoute(user: UserModel, blockedRoute: string): string {
    const normalizedBlockedRoute = blockedRoute.startsWith('/') ? blockedRoute : `/${blockedRoute}`;
    const candidates = orderedRoutes.filter((route) => route !== normalizedBlockedRoute);

    for (const route of candidates) {
        if (canAccessRoute(user, route)) {
            return route;
        }
    }

    return '/productions';
}

export function hasAnyAllowedRoute(user: UserModel): boolean {
    return orderedRoutes.some((route) => canAccessRoute(user, route));
}
